
  import * as ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as byhoursRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as s3ProviderRuntime$M4G6T7VNSb7LHEdSqlnEvpkMQ6jOUrqX9J7TpGgVMfA from '/app/app/providers/img-provider.ts'
import * as localRuntime$M4G6T7VNSb7LHEdSqlnEvpkMQ6jOUrqX9J7TpGgVMfA from '/app/app/providers/img-provider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "images.byhours.com"
  ],
  "alias": {
    "/ipx": "https://images.byhours.com"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['ipx']: { provider: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} },
  ['byhours']: { provider: byhoursRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {"baseURL":"https://images.byhours.com/_ipx"} },
  ['s3Provider']: { provider: s3ProviderRuntime$M4G6T7VNSb7LHEdSqlnEvpkMQ6jOUrqX9J7TpGgVMfA, defaults: {"baseURL":"https://images.byhours.com/img-web"} },
  ['local']: { provider: localRuntime$M4G6T7VNSb7LHEdSqlnEvpkMQ6jOUrqX9J7TpGgVMfA, defaults: {"baseURL":"https://cms.byhours.com"} }
    }
  }
